export function parentMessage(callback) {
  function listener(event) {
    callback(event);
  }

  window.addEventListener('message', listener);

  return () => {
    window.removeEventListener('message', listener);
  };
}
